import { useState, useRef } from "react"

import { LoginButton, LoginWrapper, LoginFormMain } from "./Atom"
import styles from "../../../styles/Login.module.css"
import {
  CircularProgress,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material"
import ArrowForwardIcon from "@mui/icons-material/ArrowForward"
import { useNavigate } from "react-router"
import { useSelector } from "react-redux"
import { Visibility, VisibilityOff } from "@mui/icons-material"

type ChangePasswordProps = {
  loading: boolean
  setOldPassword: any
  setNewPassword: any
  setConfirmNewPassword: any
  oldPasswordError: any
  newPasswordError: any
  confirmNewPasswordError: any
  handleChangePassword: any
}

const ChangeMyPassword = (props: ChangePasswordProps) => {
  const {
    loading,
    setOldPassword,
    setNewPassword,
    setConfirmNewPassword,
    oldPasswordError,
    newPasswordError,
    confirmNewPasswordError,
    handleChangePassword,
  } = props

  const navigate = useNavigate()

  const [showOldPassword, setShowOldPassword] = useState(false)
  const [showNewPassword, setShowNewPassword] = useState(false)

  const currentUser = useSelector((state: any) => {
    return state.admin.currentUser
  })

  const inputRefs: any = useRef([])

  const handleKeyPress = (index: any) => {
    const nextIndex = index + 1
    inputRefs.current[nextIndex]?.focus()
  }

  const handleClickEnter = (e: any, index: any) => {
    if (e.key === "Enter") {
      e.preventDefault()

      handleKeyPress(index)
    }
  }

  const handleClickSubmit = (e: any) => {
    if (e.key === "Enter") {
      e.preventDefault()

      handleChangePassword()
    }
  }

  return (
    <LoginWrapper>
      <h4 className={styles.LoginText}>CHANGE PASSWORD</h4>
      <LoginFormMain>
        <TextField
          sx={{
            marginTop: "0px",
          }}
          type="email"
          required
          label="Email"
          className={styles.TextInput}
          disabled={true}
          value={currentUser?.email}
        />
        <TextField
          sx={{
            marginTop: "15px",
          }}
          type={showOldPassword ? "text" : "password"}
          error={oldPasswordError ? true : false}
          helperText={oldPasswordError}
          required
          onChange={(e) => setOldPassword(e.target.value)}
          onKeyDown={(e) => handleClickEnter(e, 0)}
          autoFocus
          label="Old Password"
          className={styles.TextInput}
          autoComplete="off"
          inputRef={(ref) => (inputRefs.current[0] = ref)}
          InputProps={{
            endAdornment: (
              <InputAdornment
                position="end"
                onClick={() => setShowOldPassword(!showOldPassword)}
                sx={{ cursor: "pointer" }}
              >
                {showOldPassword ? <VisibilityOff /> : <Visibility />}
              </InputAdornment>
            ),
          }}
        />
        <TextField
          sx={{
            marginTop: "15px",
          }}
          type={showNewPassword ? "text" : "password"}
          error={newPasswordError ? true : false}
          helperText={newPasswordError}
          required
          onChange={(e) => setNewPassword(e.target.value)}
          onKeyDown={(e) => handleClickEnter(e, 1)}
          autoFocus
          label="New Password"
          className={styles.TextInput}
          autoComplete="off"
          inputRef={(ref) => (inputRefs.current[1] = ref)}
          InputProps={{
            endAdornment: (
              <InputAdornment
                position="end"
                onClick={() => setShowNewPassword(!showNewPassword)}
                sx={{ cursor: "pointer" }}
              >
                {showNewPassword ? <VisibilityOff /> : <Visibility />}
              </InputAdornment>
            ),
          }}
        />

        <TextField
          sx={{
            marginTop: "15px",
          }}
          type={showNewPassword ? "text" : "password"}
          error={confirmNewPasswordError ? true : false}
          helperText={confirmNewPasswordError}
          required
          onChange={(e) => setConfirmNewPassword(e.target.value)}
          onKeyDown={(e) => handleClickSubmit(e)}
          label="Confirm New Password"
          className={styles.TextInput}
          autoComplete="off"
          inputRef={(ref) => (inputRefs.current[2] = ref)}
          InputProps={{
            endAdornment: (
              <InputAdornment
                position="end"
                sx={{ cursor: "not-allowed", color: "#dedfe0" }}
              >
                {showNewPassword ? <VisibilityOff /> : <Visibility />}
              </InputAdornment>
            ),
          }}
        />
      </LoginFormMain>

      <LoginButton
        variant="contained"
        onClick={() => handleChangePassword()}
        endIcon={
          loading ? (
            <CircularProgress size={20} sx={{ color: "#FFFFFF" }} />
          ) : (
            <ArrowForwardIcon />
          )
        }
      >
        <Typography
          style={{ textTransform: "none" }}
          fontSize={16}
          fontWeight={500}
        >
          CHANGE PASSWORD
        </Typography>
      </LoginButton>
    </LoginWrapper>
  )
}

export default ChangeMyPassword
